import { createPinia, Pinia, Store } from 'pinia';

/* Pinia setup config */

/**
 * Set to maintain a reference to all active store instances.
 */
const activeStores = new Set<Store>();

const pinia: Pinia = createPinia();

/**
 * Pinia plugin to register each store in the `activeStores` Set.
 * It runs every time a store is used for the first time.
 */
pinia.use(({ store }) => {
  activeStores.add(store);
});

export { pinia, activeStores };
